import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMergeVerticesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 5,
			r: 2,
			fill: "currentColor",
			stroke: "none",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 5,
			r: 2,
			fill: "currentColor",
			stroke: "none",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 19,
			r: 2,
			fill: "currentColor",
			stroke: "none",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 2,
			fill: "currentColor",
			stroke: "none",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m7 7 3.5 3.5M17 7l-3.5 3.5M7 17l3.5-3.5M17 17l-3.5-3.5",
			opacity: .35
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 2.5,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgMergeVerticesIcon;
